import { useQuery } from "@tanstack/react-query";
import { env } from "@/lib/env";

export function useDoohAccess(userId?: string) {
	const url = new URL("/dooh/", env.API_URL).href;
	const query = useQuery({
		queryKey: ["dooh-access", userId],
		enabled: !!userId,
		queryFn: async ({ signal }) => {
			const response = await fetch(new URL("api/auth/access", url), {
				credentials: "include",
				cache: "no-store",
				signal,
			});
			if (!response.ok) return false;
			const result = await response.json();
			return result.allowed === true;
		},
		retry: false,
		staleTime: 0,
		refetchInterval: 60_000,
	});
	return {
		allowed: !!userId && query.data === true && !query.isError,
		isLoading: !!userId && query.isPending,
		url,
	};
}
